export default __webpack_public_path__ + "static/saoldisplay-mediumitalic-webfont-b77d7a4d7ed60f6ac8a8f79c8bfe85ae.woff2";